<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.name"
          :label="$t('profile.material.name')"
          type="text"
        />
      </v-col>
      <v-row cols="12"></v-row>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <h3> {{ $t('profile.material.tempresistance') }}</h3>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.tempResistance_gte"
              :label="$t('global.min')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.tempResistance_lte"
              :label="$t('global.max')"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <h3>{{ $t('profile.material.chemicalresistance') }}</h3>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.chemicalResistance_gte"
              :label="$t('global.min')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.chemicalResistance_lte"
              :label="$t('global.max')"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <h3> {{ $t('profile.material.uvresistance') }}</h3>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.uvResistance_gte"
              :label="$t('global.min')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.uvResistance_lte"
              :label="$t('global.max')"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <h3>{{ $t('profile.material.mecaresistance') }}</h3>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.mecaResistance_gte"
              :label="$t('global.min')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.mecaResistance_lte"
              :label="$t('global.max')"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <h3> {{ $t('profile.material.abrasionresistance') }}</h3>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.abrasionResistance_gte"
              :label="$t('global.min')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.abrasionResistance_lte"
              :label="$t('global.max')"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <h3>{{ $t('profile.material.tractionresistance') }}</h3>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.tractionResistance_gte"
              :label="$t('global.min')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.tractionResistance_lte"
              :label="$t('global.max')"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <h3> {{ $t('profile.material.complexity') }}</h3>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.complexity_gte"
              :label="$t('global.min')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.complexity_lte"
              :label="$t('global.max')"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <h3>{{ $t('profile.material.density') }}</h3>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.density_gte"
              :label="$t('global.min')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.density_lte"
              :label="$t('global.max')"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <h3> {{ $t('profile.material.elongation') }}</h3>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.elongation_gte"
              :label="$t('global.min')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.elongation_lte"
              :label="$t('global.max')"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <h3>{{ $t('profile.material.tenacity') }}</h3>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.tenacity_gte"
              :label="$t('global.min')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.tenacity_lte"
              :label="$t('global.max')"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <h3> {{ $t('profile.material.cost') }}</h3>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.cost_gte"
              :label="$t('global.min')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.cost_lte"
              :label="$t('global.max')"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <h3> {{ $t('profile.material.dielectric') }}</h3>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.dielectric_gte"
              :label="$t('global.min')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.dielectric_lte"
              :label="$t('global.max')"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <h3> {{ $t('profile.material.electrical') }}</h3>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.electrical_gte"
              :label="$t('global.min')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.electrical_lte"
              :label="$t('global.max')"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <h3>{{ $t('profile.material.thermal') }}</h3>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.thermal_gte"
              :label="$t('global.min')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.thermal_lte"
              :label="$t('global.max')"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <h3>{{ $t('profile.material.hardnessshore') }}</h3>
        <v-row>
        <v-combobox
          v-if="hardnessShoreTypeSelectItems"
          v-model="item.hardnessShoreType"
          :items="hardnessShoreTypeSelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('profile.material.hardnessshoretype')"
          item-text="name"
          item-value="@id"
        />
        </v-row>
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.hardnessShore_gte"
              :label="$t('global.min')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.hardnessShore_lte"
              :label="$t('global.max')"
              type="number"
            ></v-text-field>
          </v-col>
          </v-row>
      </v-col>

    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <h3>{{ $t('profile.material.hardness') }}</h3>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.hardness_gte"
              :label="$t('global.min')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.hardness_lte"
              :label="$t('global.max')"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <h3>{{ $t('profile.material.tempfusion') }}</h3>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.tempFusion_gte"
              :label="$t('global.min')"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="item.tempFusion_lte"
              :label="$t('global.max')"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'MaterialTypeFilter',
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {
      this.hardnessShoreTypeGetSelectItems();
  },
  computed: {
    ...mapFields('hardnessshoretype', {
      hardnessShoreTypeSelectItems: 'selectItems',
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    }
  },
  methods: {
    ...mapActions({

      hardnessShoreTypeGetSelectItems: 'hardnessshoretype/fetchSelectItems'
    }),
  }
};
</script>
